<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span><i>Contents</i></span></p>
<p class="toc-text"><span><a href="#/xhtml/fm01"><span class="smallcaps">CONVERSATION</span></a></span></p>
<p class="toc-text1"><span><a href="#/xhtml/part01"><i>Part One</i> PERAMA</a></span></p>
<p class="toc-text"><span><a href="#/xhtml/chapter001">1 <span class="smallcaps">THE CHRISTENING</span></a></span></p>
<p class="toc-text"><span><a href="#/xhtml/chapter002">2 <span class="smallcaps">THE BAY OF OLIVES</span></a></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter003" title="Link target outside of Sample">3 <span class="smallcaps">THE MYRTLE FORESTS</span></span></span></p>
<p class="toc-text1"><span><span href="#/xhtml/part02" title="Link target outside of Sample"><i>Part Two</i> KONTOKALI</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter004" title="Link target outside of Sample">4 <span class="smallcaps">THE PYGMY JUNGLE</span></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter005" title="Link target outside of Sample">5 <span class="smallcaps">CUTTLEFISH AND CRABS</span></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter06" title="Link target outside of Sample"><span class="smallcaps">INTERLUDE FOR SPIRITS</span></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter006" title="Link target outside of Sample">6 <span class="smallcaps">THE OLIVE MERRY-GO-ROUND</span></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter007" title="Link target outside of Sample">7 <span class="smallcaps">OWLS AND ARISTOCRACY</span></span></span></p>
<p class="toc-text1"><span><span href="#/xhtml/part04" title="Link target outside of Sample"><i>Part Three</i> CRISEDA</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter008" title="Link target outside of Sample">8 <span class="smallcaps">HEDGEHOGS AND SEA-DOGS</span></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter009" title="Link target outside of Sample">9 <span class="smallcaps">THE TALKING HEAD</span></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter010" title="Link target outside of Sample">10 <span class="smallcaps">THE ANGRY BARRELS</span></span></span></p>
<p class="toc-text1"><span><span href="#/xhtml/endmatter1" title="Link target outside of Sample"><i>Epilogue</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/endmatter2" title="Link target outside of Sample"><span class="smallcaps">MAIL</span></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/preview" title="Link target outside of Sample">Preview: <i>The Garden of the Gods</i></span></span></p>
<p class="toc-text"><span><span href="#/xhtml/bio" title="Link target outside of Sample">A Biography of Gerald Durrell</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/endmatter3" title="Link target outside of Sample">A Message from Durrell Wildlife</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?986d3e02